import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Virtuoso } from 'react-virtuoso';
import { vars } from 'src/core/themes';
import { ListingDetails } from 'src/WebApiController';

import { getSeatDisplay } from '../ListingDetails/components';

export const ViewSeatsListBody = ({
  listing,
  seeAvailableSeats,
  seeWastedSeats,
}: {
  listing?: ListingDetails | null;
  seeAvailableSeats?: boolean;
  seeWastedSeats?: boolean;
}) => {
  const navigate = useNavigate();
  const tickets = listing?.tickets;
  const seatsElements = useMemo(() => {
    if (tickets) {
      if (seeWastedSeats) {
        return tickets
          .filter((t) => t.saleId && t.isWasted)
          .map((t) => getSeatDisplay(t, navigate));
      } else if (seeAvailableSeats) {
        return tickets.filter((t) => !t.saleId).map((t) => getSeatDisplay(t));
      } else {
        return tickets
          .filter((t) => t.saleId)
          .map((t) => getSeatDisplay(t, navigate));
      }
    }
  }, [tickets, seeWastedSeats, seeAvailableSeats, navigate]);

  return (
    <Virtuoso
      style={{ padding: vars.spacing.xl }}
      data={seatsElements}
      itemContent={(_, seatsElement) => {
        return <div style={{ padding: vars.spacing.xxs }}>{seatsElement}</div>;
      }}
    />
  );
};
